import React, { useEffect, useMemo, useState } from 'react'
import { loadUserTalents, loadTalent, deleteUserTalent } from '../utils/Network';

import { getAge, getDefaultName, isAdmin, isNumber, userAvatar } from '../utils';
import CityName from '../components/CityName';
import { Link, useParams } from 'react-router-dom';
import SelectCourses from '../components/SelectCourses';
import SelectGender from '../components/SelectGender';
import SelectYear from '../components/SelectYear';
import SelectMonth from '../components/SelectMonth';
import SelectCountries from '../components/SelectCountries';
import SelectCities from '../components/SelectCities';
import SelectSize from '../components/SelectSize';
import HasUserTalentDocument from '../components/HasUserTalentDocument';
import SelectVerified from '../components/select/SelectVerified';
import SelectShowUserDocumentsOnly from '../components/select/SelectShowUserDocumentsOnly';

function userListInitialFromTalent(item) {
    const profile = item?.user?.profile || {};
    const fn = profile.first_name && String(profile.first_name).trim();
    const ln = profile.last_name && String(profile.last_name).trim();
    const em = (item?.user?.email || profile.email) && String(item?.user?.email || profile.email).trim();
    const name = fn || ln || em || '?';
    return name.charAt(0).toUpperCase();
}

function hslBackgroundForId(id) {
    const n = Number(id) || 0;
    const h = (n * 47) % 360;
    return `hsl(${h}, 55%, 42%)`;
}

function buildPaginationItems(currentPage, totalPages, windowSize = 5) {
    const total = totalPages;
    const cur = Math.max(1, Math.min(Number(currentPage) || 1, total));
    if (total <= windowSize + 2) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }
    let winEnd = Math.min(total, Math.max(windowSize, cur + Math.floor(windowSize / 2)));
    let winStart = Math.max(1, winEnd - windowSize + 1);
    winEnd = Math.min(total, winStart + windowSize - 1);
    winStart = Math.max(1, winEnd - windowSize + 1);
    const items = [];
    if (winStart > 1) {
        items.push(1);
        if (winStart > 2) items.push('ellipsis');
    }
    for (let p = winStart; p <= winEnd; p++) items.push(p);
    if (winEnd < total) {
        if (winEnd < total - 1) items.push('ellipsis');
        items.push(total);
    }
    return items;
}

function talentListPageHref(talentId, pageNum, searchParams) {
    const q = searchParams && searchParams.toString() ? `?${searchParams.toString()}` : '';
    const p = Number(pageNum) || 1;
    if (p <= 1) return `/cms/talent/${talentId}${q}`;
    return `/cms/talent/${talentId}/${p}${q}`;
}

export default function TalentDetails({ urlParams }) {

    const [loading, setLoading] = useState(0);

    const [talent, setTalent] = useState(null);
    const [count, setCount] = useState(null);
    const [userTalents, setUserTalents] = useState(null);
    const [pages, setPages] = useState(null);
    const [show_delete, setShowDelete] = useState(false);
    const [page_size, setPageSize] = useState(30);
    const [show_filter, setShowFilter] = useState(false);

    var { id, page } = useParams();
    const currentPage = Number(page) || 1;

    const [filter_course_value, setFilterCourseValue] = useState(null);
    const [filter_is_verified_value, setFilterIsVerifiedValue] = useState(null);
    const [filter_with_user_documents_only_value, setFilterWithUserDocumentsOnly] = useState(null);

    const [filter_gender_value, setFilterGenderValue] = useState(null);
    const [filter_size_value, setFilterSizeValue] = useState(null);

    const [filter_from_year_value, setFilterFromYearValue] = useState(null);
    const [filter_from_month_value, setFilterFromMonthValue] = useState(null);

    const [filter_to_year_value, setFilterToYearValue] = useState(null);
    const [filter_to_month_value, setFilterToMonthValue] = useState(null);

    const [filter_birth_country_value, setFilterBirthCountryValue] = useState(null);
    const [filter_birth_city_value, setFilterBirthCityValue] = useState(null);
    const [filter_living_country_value, setFilterLivingCountryValue] = useState(null);
    const [filter_living_city_value, setFilterLivingCityValue] = useState(null);


    //Filters
    let filter_first_name = urlParams.get('first_name');
    let filter_last_name = urlParams.get('last_name');
    let filter_gender = urlParams.get('gender');
    let filter_birth_country = urlParams.get('country');
    let filter_birth_city = urlParams.get('city');
    let filter_living_country = urlParams.get('living_country');
    let filter_living_city = urlParams.get('living_city');
    let filter_talent = urlParams.get('talent');
    let filter_course = urlParams.get('course');
    let filter_size = urlParams.get('size') ? urlParams.get('size') : 50;
    let filter_is_verified = urlParams.get('is_verified') ? urlParams.get('is_verified') : 1;
    let filter_with_user_documents_only = urlParams.get('with_user_documents_only') ? urlParams.get('with_user_documents_only') : 0;

    let filter_from_year = isNumber(urlParams.get('from_year')) ? urlParams.get('from_year') : null;

    let filter_from_month = urlParams.get('from_month');
    let filter_from_day = urlParams.get('from_day');
    let filter_fbirthdate = "";

    if (filter_from_year) {
        filter_from_month = isNumber(filter_from_month) ? filter_from_month : 1;
        filter_from_day = isNumber(filter_from_day) ? filter_from_day : 1;
        filter_fbirthdate = filter_from_year + "-" + filter_from_month + "-" + filter_from_day;
    }


    let filter_to_year = isNumber(urlParams.get('to_year')) ? urlParams.get('to_year') : null;
    let filter_to_month = urlParams.get('to_month');
    let filter_to_day = urlParams.get('to_day');
    let filter_tbirthdate = "";
    if (filter_to_year) {
        filter_to_month = isNumber(filter_to_month) ? filter_to_month : 1;
        filter_to_day = isNumber(filter_to_day) ? filter_to_day : 1;
        filter_tbirthdate = filter_to_year + "-" + filter_to_month + "-" + filter_to_day;
    }

    //Creating Filter Query

    let filter_query = "&is_active=1";
    var filtered = false;


    if (filter_is_verified) {
        if (filter_is_verified != "-1") {
            filter_query += "&is_verified=" + filter_is_verified;
        }
        //filtered = true;

    }
    if (filter_with_user_documents_only) {
        if (filter_with_user_documents_only == 1) {
            filter_query += "&with_user_documents_only=1";
        }
        //filtered = true;

    }



    if (filter_first_name && filter_first_name.length > 0) {
        filter_query += "&first_name=" + filter_first_name;
        filtered = true;
    }

    if (filter_last_name && filter_last_name.length > 0) {
        filter_query += "&last_name=" + filter_last_name;
        filtered = true;
    }

    if (filter_gender && filter_gender.length > 0) {
        filter_query += "&gender=" + filter_gender;
        filtered = true;
    }

    if (filter_birth_country && filter_birth_country.length > 0) {

        filter_query += "&country=" + filter_birth_country;
        filtered = true;
    }

    if (filter_birth_city && filter_birth_city.length > 0) {
        filter_query += "&city=" + filter_birth_city;
        filtered = true;
    }

    if (filter_living_country && filter_living_country.length > 0) {
        filter_query += "&livingcountry=" + filter_living_country;
        filtered = true;
    }



    if (filter_living_city && filter_living_city.length > 0) {
        filter_query += "&livingcity=" + filter_living_city;
        filtered = true;
    }

    if (filter_fbirthdate && filter_fbirthdate.length > 0) {
        filter_query += "&fbirthdate=" + filter_fbirthdate;
        filtered = true;
    }
    if (filter_tbirthdate && filter_tbirthdate.length > 0) {
        filter_query += "&tbirthdate=" + filter_tbirthdate;
        filtered = true;
    }

    if (filter_talent && isNumber(filter_talent)) {
        filter_query += "&talent=" + filter_talent;
        filtered = true;
    }

    if (filter_course && isNumber(filter_course)) {
        filter_query += "&course=" + filter_course;
        filtered = true;
    }

    if (filter_size && isNumber(filter_size)) {
        filter_query += "&size=" + filter_size;
    }
    // End Filters

    const params = useParams()

    useEffect(() => {
        if (params.gender !== null || params.with_user_documents_only==1) {
            _getUserTalents(id)
        }
    }, [params]);


    useEffect(() => {
        _getData()


        setFilterCourseValue(filter_course)
        setFilterGenderValue(filter_gender)
        setFilterBirthCountryValue(filter_birth_country)
        setFilterBirthCityValue(filter_birth_city)
        setFilterLivingCountryValue(filter_living_country)
        setFilterLivingCityValue(filter_living_city)
        setFilterFromYearValue(filter_from_year)
        setFilterFromMonthValue(filter_from_month)
        setFilterToYearValue(filter_to_year)
        setFilterToMonthValue(filter_to_month)
        setFilterSizeValue(filter_size)
        setFilterIsVerifiedValue(filter_is_verified)
        setFilterWithUserDocumentsOnly(filter_with_user_documents_only)

    }, [id, currentPage, filter_query]);

    const _getData = () => {
        if (id) {
            loadTalent(id).then(talent => {
                setTalent(talent);
                _getUserTalents(id)
            });
        }
    }

    const _getUserTalents = (talent_id) => {
        loadUserTalents(talent_id, currentPage, filter_query).then(data => {
            if (data && data.count) {

                setCount(data.count)
                var page_count = data.count % filter_size === 0 ? parseInt(data.count / filter_size) : parseInt(data.count / filter_size) + 1;
                var pages_array = range(1, page_count);
                setPages(pages_array);
            }
            if (data && data.results) {
                setUserTalents(data.results);
            }

        })
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    const totalPages = pages?.length || 0;
    const paginationItems = useMemo(() => {
        if (!pages?.length) return [];
        return buildPaginationItems(currentPage, pages.length);
    }, [pages, currentPage]);
    const canGoPrev = totalPages > 0 && currentPage > 1;
    const canGoNext = totalPages > 0 && currentPage < totalPages;

    const handleDelete = (usertalent_id, e) => {
        setLoading(usertalent_id);
        deleteUserTalent(usertalent_id).then(() => {
            loadUserTalents(id, currentPage, filter_query).then(data => {
                if (data) {
                    if (data.count)
                        setCount(data.count)
                    if (data.results)
                        setUserTalents(data.results)
                }
            });
        })
    }


    function BadgeClass(value) {

        if (value < 30) {

            return "badge bg-red mr-10";
        }
        else if (value < 50) {
            return "badge bg-yellow mr-10";
        }
        else if (value < 70) {
            return "badge bg-light-blue mr-10";
        }
        else if (value <= 100) {
            return "badge bg-green mr-10";
        }


    }

    const onValue = (value, name) => {
        // alert(name)
        switch (name) {
            case "course":
                setFilterCourseValue(value)
                break;
            case "is_verified":
                setFilterIsVerifiedValue(value)
                break;
            case "from_year":
                setFilterFromYearValue(value)
                break;
            case "from_month":
                setFilterFromMonthValue(value)
                break;
            case "to_year":
                setFilterToYearValue(value)
                break;
            case "to_month":
                setFilterToMonthValue(value)
                break;
            case "gender":
                setFilterGenderValue(value)
                break;
            case "size":
                setFilterSizeValue(value)
                break;
            case "country":
                setFilterBirthCountryValue(value)
                break;
            case "city":
                setFilterBirthCityValue(value)
                break;
            case "living_country":
                setFilterLivingCountryValue(value)
                break;
            case "living_city":
                setFilterLivingCityValue(value)
                break;
            case "filter_with_user_documents_only":
                setFilterWithUserDocumentsOnly(value)
                break;
            default:
                break;
        }
    }

    const showFilters = (e) => {
        e.preventDefault();
        setShowFilter(!show_filter)
        filtered = false;
    }

    return (
        <>
            <div className="content-wrapper">
                {/* <section className="content-header" style={{ maxWidth: '1550px' }}>
                    <h3 className="box-title mb-10">
                        <span className="sr-only">Talent</span>
                    </h3>
                    <ol className="breadcrumb">
                        <li>
                            <a href="/cms">
                                <i className="fa fa-dashboard"></i> Home
                            </a>
                        </li>
                        <li className="active">{talent && getDefaultName(talent.names)} talents</li>
                    </ol>
                </section> */}

                <section className="content">

                    {(show_filter || filtered) &&
                        <div class="boxbg-f9">
                            <form action="" className="form-horizontal">
                                <div className="box-body padding-10">
                                    <div className="mb-10">
                                        <div className="col-md-7 padding-l-0 ">
                                            <div className="col-md-6 padding-0 mb-10 padding-r-5">
                                                <input type="text" name="first_name" defaultValue={filter_first_name} className="form-control" placeholder="First Name" />
                                            </div>
                                            <div className="col-md-6 mb-10  padding-0 ">
                                                <input type="text" name="last_name" defaultValue={filter_last_name} className="form-control" placeholder="Last Name" />

                                            </div>
                                            <div className="col-md-12 padding-0">
                                                <div className="pull-left margin-r-10 mb-10 padding-0">
                                                    <SelectGender value={filter_gender_value} width="130px" border="1" callback={onValue} />
                                                    <input type="hidden" name="gender" value={filter_gender_value} />
                                                </div>
                                                <div className="pull-left margin-r-10 mb-10 padding-0">
                                                    <SelectCourses value={filter_course_value} width="195px" border="1" callback={onValue} />
                                                    <input type="hidden" name="course" value={filter_course_value} />
                                                </div>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="col-md-5  padding-10" style={{ backgroundColor: '#374355', color: 'white' }}>
                                            <div className="row">
                                                <label className="col-lg-12">Date of Birth</label>
                                                <div className="col-lg-6 col-sm-12 padding-r-0 ">
                                                    <label className="col-lg-12 padding-0">From</label>
                                                    <div className="col-lg-12  padding-0">
                                                        <div className="pull-left">
                                                            <SelectYear value={filter_from_year_value} name="from_year" width="80px" border="1" callback={onValue} />
                                                            <input type="hidden" name="from_year" value={filter_from_year_value} />

                                                        </div>
                                                        <div className="pull-left margin-l-5">
                                                            <SelectMonth value={filter_from_month_value} name="from_month" width="90px" border="1" callback={onValue} />
                                                            <input type="hidden" name="from_month" value={filter_from_month_value} />
                                                        </div>
                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                                <div className="col-lg-6  col-sm-12 padding-r-0">
                                                    <label className="col-lg-12 padding-0">To</label>
                                                    <div className="col-lg-12 padding-0">
                                                        <div className="pull-left">
                                                            <SelectYear value={filter_to_year_value} name="to_year" width="80px" border="1" callback={onValue} />
                                                            <input type="hidden" name="to_year" value={filter_to_year_value} />
                                                        </div>
                                                        <div className="pull-left margin-l-5">
                                                            <SelectMonth value={filter_to_month_value} name="to_month" width="90px" border="1" callback={onValue} />
                                                            <input type="hidden" name="to_month" value={filter_to_month_value} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                    <div className="">
                                        <div className="col-md-6  padding-10" style={{ backgroundColor: '#374355', color: 'white' }}>
                                            <div className="col-md-12 padding-0">
                                                <label>Born in</label>
                                            </div>
                                            <div className="pull-left margin-r-10 mb-10">
                                                <SelectCountries kurds={1} value={filter_birth_country_value} name="country" width="220px" border="1" callback={onValue} />
                                                <input type="hidden" name="country" value={filter_birth_country_value} />
                                            </div>
                                            <div className="pull-left ">
                                                <SelectCities country={filter_birth_country_value} key={filter_birth_country_value} value={filter_birth_city_value} name="city" width="210px" border="1" callback={onValue} />
                                                <input type="hidden" name="city" value={filter_birth_city_value} />
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="col-md-6  padding-0 ">
                                            <div className="padding-10 padding-l-5 " style={{ backgroundColor: '#374355', color: 'white', }}>
                                                <div className="col-md-12 padding-0">
                                                    <label>Living in</label>
                                                </div>
                                                <div className="pull-left margin-r-10 mb-10 ">
                                                    <SelectCountries value={filter_living_country_value} name="living_country" width="210px" border="1" callback={onValue} />
                                                    <input type="hidden" name="living_country" value={filter_living_country_value} />
                                                </div>
                                                <div className="pull-left ">
                                                    <SelectCities country={filter_living_country_value} key={filter_living_country_value} value={filter_living_city_value} name="living_city" width="210px" border="1" callback={onValue} />
                                                    <input type="hidden" name="living_city" value={filter_living_city_value} />
                                                </div>
                                                <div className="clear"></div>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="clear"></div>
                                    </div>


                                </div>
                                <div className="box-footer bg-f9">
                                    <div className="pull-left ">
                                        <SelectSize value={filter_size_value} name="size" width="100px" border="1" callback={onValue} />
                                        <input type="hidden" name="size" value={filter_size_value} />
                                    </div>
                                    <div className="pull-left ">
                                        <SelectVerified value={filter_is_verified_value} name="is_verified" width="100px" border="1" callback={onValue} />
                                        <input type="hidden" name="is_verified" value={filter_is_verified_value} />
                                    </div>
                                    <div className="pull-left ">
                                        <SelectShowUserDocumentsOnly value={filter_with_user_documents_only_value} name="filter_with_user_documents_only" width="200px" border="1" callback={onValue} />
                                        <input type="hidden" name="with_user_documents_only" value={filter_with_user_documents_only_value} />
                                    </div>
                                    <button type="submit" className="btn btn-cm pull-right">
                                        <i className="fa fa-filter"></i>
                                    </button>
                                    <a href={`talent/${id ? id : ""}`} className="btn btn-cm pull-right mr-1">Cancel</a>
                                </div>
                            </form>
                        </div>
                    }

                    <div className="box box-primary">
                        <div className="box-header with-border">
                            <h3 className="box-title">
                                {talent && getDefaultName(talent.names)}
                                {count != null && (
                                    <span style={{ fontSize: 11, marginLeft: '0.35em' }}>({count})</span>
                                )}
                            </h3>
                            {isAdmin() && (
                                <button
                                    type="button"
                                    title="Show Delete Button"
                                    className="btn btn-cm margin-r-5 pull-right"
                                    onClick={showDelete}
                                >
                                    <i className="fa fa-trash"></i>
                                </button>
                            )}
                            <button
                                type="button"
                                title="Filters"
                                className="btn btn-cm margin-r-5 pull-right"
                                onClick={showFilters}
                            >
                                <i className="fa fa-filter"></i>
                            </button>
                        </div>
                        <div className="box-body no-padding">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Age</th>
                                        <th className="hide-on-small">Gender</th>
                                        <th className="hide-on-small">POB</th>
                                        <th style={{ width: 50 }}>
                                            <Link to={`${ filter_with_user_documents_only ? `/cms/talent/${id ? id : ""}` : '?with_user_documents_only=1' }`}>
                                                <i className="fa fa-play"></i>
                                            </Link>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userTalents && userTalents.map((item) => (
                                        <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                            <td>
                                                <div className="img-container">
                                                    <a href={`/cms/usertalent/${item.user.profile && item.user.profile.id}`}>
                                                        {item.user?.profile && item.user.profile.image ? (
                                                            <img
                                                                src={userAvatar(item.user.profile)}
                                                                className="pull-left img-list img-circle margin-r-10"
                                                                alt=""
                                                            />
                                                        ) : (
                                                            <div
                                                                className="pull-left img-list img-circle margin-r-10 users-letter-avatar"
                                                                style={{
                                                                    backgroundColor: hslBackgroundForId(
                                                                        item?.user?.id || item?.id
                                                                    ),
                                                                }}
                                                                aria-hidden
                                                            >
                                                                {userListInitialFromTalent(item)}
                                                            </div>
                                                        )}
                                                    </a>
                                                </div>
                                                <a href={`/cms/usertalent/${item.user.profile && item.user.profile.id}`} className="link-color">
                                                    <p className="text-capitalize mb-0 text-light kfont">
                                                        {item.user.profile && item.user.profile.first_name}{' '}
                                                        {item.user.profile && item.user.profile.last_name}
                                                    </p>
                                                    <p title="Registered date" style={{ color: '#949090', fontSize: 11 }}>
                                                        {item.user?.profile?.created_at &&
                                                            item.user.profile.created_at.split(' ')[0]}
                                                    </p>
                                                </a>
                                            </td>
                                            <td>{item.user?.profile?.birth_date} <br />

                                                {(() => {
                                                    const age = getAge(item.user.profile && item.user.profile.birth_date);
                                                    return age !== undefined && age !== null && age !== 0 && age !== "" ? (
                                                        <small>{age} Years old</small>
                                                    ) : null;
                                                })()}
                                            </td>
                                            <td className="hide-on-small">
                                                <Link to={`?gender=${item.user.profile && item.user.profile.gender}`}>
                                                    {item.user.profile && item.user.profile.gender === 0 ? "Male" : item.user.profile && item.user.profile.gender === 1 ? "Female" : "Other"}
                                                </Link>
                                            </td>
                                            <td className="hide-on-small">{item.user?.profile?.city && getDefaultName(item.user.profile.city.names)}</td>

                                            <td >
                                                <div className="d-flex justify-content-center gap-2" style={{gap: "5px"}}>
                                                    <HasUserTalentDocument userdocuments={item && item.userdocuments} />
                                                    <div className="btn-group">
                                                        {show_delete &&
                                                            <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        }

                                                </div>

                                                </div>
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Name</th>
                                        <th>Age</th>
                                        <th className="hide-on-small">Gender</th>
                                        <th className="hide-on-small">POB</th>
                                        <th></th>
                                    </tr>
                                </tfoot>
                            </table>

                        </div>

                    </div>

                    <ul className="pagination cms-pagination ">
                        <li className={`page-item${!canGoPrev ? ' disabled' : ''}`}>
                            <a
                                className="page-link"
                                href={canGoPrev ? talentListPageHref(id, currentPage - 1, urlParams) : '#'}
                                onClick={!canGoPrev ? (e) => e.preventDefault() : undefined}
                                aria-disabled={!canGoPrev}
                            >
                                «
                            </a>
                        </li>
                        {paginationItems.map((entry, idx) => (
                            <li
                                key={entry === 'ellipsis' ? `e-${idx}` : entry}
                                className="page-item"
                            >
                                {entry === 'ellipsis' ? (
                                    <span
                                        className="page-link disabled"
                                        style={{ border: 'none', background: 'transparent' }}
                                    >
                                        …
                                    </span>
                                ) : (
                                    <a
                                        className={entry === currentPage ? 'page-link active' : 'page-link'}
                                        href={talentListPageHref(id, entry, urlParams)}
                                    >
                                        {entry}
                                    </a>
                                )}
                            </li>
                        ))}
                        <li className={`page-item${!canGoNext ? ' disabled' : ''}`}>
                            <a
                                className="page-link"
                                href={canGoNext ? talentListPageHref(id, currentPage + 1, urlParams) : '#'}
                                onClick={!canGoNext ? (e) => e.preventDefault() : undefined}
                                aria-disabled={!canGoNext}
                            >
                                »
                            </a>
                        </li>
                    </ul>

                </section>
            </div>
        </>


    )

}
